var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer-content"},[_c('footer',{style:(_vm.brandingColor)},[_c('a',{staticClass:"justify-content-center",style:(_vm.brandingAccentColor),attrs:{"href":"http://www.edams.com/","target":"blank"}},[_vm._v("© "+_vm._s(_vm.getCopyrightMessage())+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }